export const defaultInput = `@ via @@0 b=10000 p=x d=100000000
@@1: line x.0 t=100000000 -> @@0
@ via @@0 b=10000 p=x d=100000000
@ via @@1 b=10000 p=x d=100000000
@@2: line x.0 t=100000000 -> @@0
@ via @@0 b=10000 p=x d=100000000
@ via @@1 b=10000 p=x d=100000000
@ via @@2 b=10000 p=x d=100000000
@@3: line x.0 t=100000000 -> @@0
@ via @@0 b=10000 p=x d=100000000
@ via @@1 b=10000 p=x d=100000000
@ via @@2 b=10000 p=x d=100000000
@ via @@3 b=10000 p=x d=100000000
@@4: line x.0 t=100000000 -> @@0
@ via @@0 b=10000 p=x d=100000000
@ via @@1 b=10000 p=x d=100000000
@ via @@2 b=10000 p=x d=100000000
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@@5: line x.0 t=100000000 -> @@0
@ via @@0 b=10000 p=x d=100000000
@ via @@1 b=10000 p=x d=100000000
@ via @@2 b=10000 p=x d=100000000
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@ via @@5 b=10000 p=x d=100000000
@@6: line x.0 t=100000000 -> @@0
@ via @@0 b=6 p=x d=256
@ via @@1 b=3525 p=x d=12496225
@ via @@2 b=10000 p=x d=100000000
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@@7: line x.2 t=256 -> @@0
@@8: line x.0 t=112496225 -> @@1
@ via @@1 b=6 p=x d=256
@ via @@2 b=10000 p=x d=100000000
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@@9: line x.0 t=100000256 -> @@7
@@10: line x.2 t=100000256 -> @@1
@ via @@2 b=1377 p=x d=1923769
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@@11: line x.0 t=100000256 -> @@7
@ via @@2 b=0 p=x d=100
@ via @@3 b=10000 p=x d=100000000
@ via @@4 b=10000 p=x d=100000000
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@ via @@11 b=10000 p=x d=100000000
@@12: line x.0 t=100000256 -> @@7
@@13: line x.2 t=100000100 -> @@2
@ via @@4 b=1377 p=x d=1923769
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@ via @@11 b=10000 p=x d=100000000
@ via @@12 b=10000 p=x d=100000000
@ via @@13 b=10000 p=x d=100000000
@@14: line x.0 t=100000256 -> @@7
@ via @@5 b=10000 p=x d=100000000
@ via @@6 b=10000 p=x d=100000000
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@ via @@11 b=10000 p=x d=100000000
@ via @@12 b=10000 p=x d=100000000
@ via @@13 b=10000 p=x d=100000000
@ via @@14 b=10000 p=x d=100000000
@@15: line x.0 t=100000256 -> @@7
@ via @@6 b=1377 p=x d=1923769
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@ via @@11 b=10000 p=x d=100000000
@ via @@12 b=10000 p=x d=100000000
@ via @@13 b=10000 p=x d=100000000
@ via @@14 b=10000 p=x d=100000000
@ via @@15 b=10000 p=x d=100000000
@@16: line x.0 t=100000256 -> @@7
@ via @@7 b=10000 p=x d=100000000
@ via @@8 b=10000 p=x d=100000000
@ via @@9 b=10000 p=x d=100000000
@ via @@10 b=10000 p=x d=100000000
@ via @@11 b=10000 p=x d=100000000
@ via @@12 b=10000 p=x d=100000000
@ via @@13 b=10000 p=x d=100000000
@ via @@14 b=10000 p=x d=100000000
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@@17: line x.0 t=100000256 -> @@7
@ via @@7 b=0 p=x d=100
@ via @@8 b=0 p=x d=100
@ via @@9 b=1377 p=x d=1923769
@ via @@10 b=1377 p=x d=1923769
@ via @@11 b=10000 p=x d=100000000
@ via @@12 b=10000 p=x d=100000000
@ via @@13 b=10000 p=x d=100000000
@ via @@14 b=10000 p=x d=100000000
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@ via @@17 b=10000 p=x d=100000000
@@18: line x.0 t=101924025 -> @@10
@@19: line x.2 t=356 -> @@7
@ via @@11 b=6 p=x d=256
@ via @@12 b=3525 p=x d=12496225
@ via @@13 b=3525 p=x d=12496225
@ via @@14 b=10000 p=x d=100000000
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@@20: line x.0 t=100000356 -> @@19
@@21: line x.2 t=100000512 -> @@11
@ via @@12 b=6 p=x d=256
@ via @@13 b=6 p=x d=256
@ via @@14 b=10000 p=x d=100000000
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@@22: line x.0 t=100000356 -> @@19
@@23: line x.2 t=100000356 -> @@13
@ via @@14 b=1377 p=x d=1923769
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@@24: line x.0 t=100000356 -> @@19
@ via @@14 b=0 p=x d=100
@ via @@15 b=10000 p=x d=100000000
@ via @@16 b=10000 p=x d=100000000
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@ via @@24 b=10000 p=x d=100000000
@@25: line x.0 t=100000356 -> @@19
@@26: line x.2 t=100000356 -> @@14
@ via @@16 b=1377 p=x d=1923769
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@ via @@24 b=10000 p=x d=100000000
@ via @@25 b=10000 p=x d=100000000
@ via @@26 b=10000 p=x d=100000000
@@27: line x.0 t=100000356 -> @@19
@ via @@17 b=10000 p=x d=100000000
@ via @@18 b=10000 p=x d=100000000
@ via @@19 b=10000 p=x d=100000000
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@ via @@24 b=10000 p=x d=100000000
@ via @@25 b=10000 p=x d=100000000
@ via @@26 b=10000 p=x d=100000000
@ via @@27 b=10000 p=x d=100000000
@@28: line x.0 t=100000356 -> @@19
@ via @@18 b=1377 p=x d=1923769
@ via @@19 b=1377 p=x d=1923769
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@ via @@24 b=10000 p=x d=100000000
@ via @@25 b=10000 p=x d=100000000
@ via @@26 b=10000 p=x d=100000000
@ via @@27 b=10000 p=x d=100000000
@ via @@28 b=10000 p=x d=100000000
@@29: line x.0 t=1924125 -> @@19
@ via @@20 b=10000 p=x d=100000000
@ via @@21 b=10000 p=x d=100000000
@ via @@22 b=10000 p=x d=100000000
@ via @@23 b=10000 p=x d=100000000
@ via @@24 b=10000 p=x d=100000000
@ via @@25 b=10000 p=x d=100000000
@ via @@26 b=10000 p=x d=100000000
@ via @@27 b=10000 p=x d=100000000
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@@30: line x.0 t=101924125 -> @@29
@ via @@20 b=0 p=x d=100
@ via @@21 b=0 p=x d=100
@ via @@22 b=1377 p=x d=1923769
@ via @@23 b=1377 p=x d=1923769
@ via @@24 b=10000 p=x d=100000000
@ via @@25 b=10000 p=x d=100000000
@ via @@26 b=10000 p=x d=100000000
@ via @@27 b=10000 p=x d=100000000
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@ via @@30 b=10000 p=x d=100000000
@@31: line x.2 t=100000456 -> @@20
@@32: line x.0 t=101924125 -> @@29
@ via @@24 b=6 p=x d=256
@ via @@25 b=3525 p=x d=12496225
@ via @@26 b=3525 p=x d=12496225
@ via @@27 b=10000 p=x d=100000000
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@@33: line x.0 t=101924125 -> @@29
@@34: line x.2 t=100000612 -> @@24
@ via @@25 b=6 p=x d=256
@ via @@26 b=6 p=x d=256
@ via @@27 b=10000 p=x d=100000000
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@@35: line x.2 t=100000612 -> @@26
@@36: line x.0 t=101924125 -> @@29
@ via @@27 b=1377 p=x d=1923769
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@@37: line x.0 t=101924125 -> @@29
@ via @@27 b=0 p=x d=100
@ via @@28 b=10000 p=x d=100000000
@ via @@29 b=10000 p=x d=100000000
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@ via @@37 b=10000 p=x d=100000000
@@38: line x.2 t=100000456 -> @@27
@@39: line x.0 t=101924125 -> @@29
@ via @@29 b=1377 p=x d=1923769
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@ via @@37 b=10000 p=x d=100000000
@ via @@38 b=10000 p=x d=100000000
@ via @@39 b=10000 p=x d=100000000
@@40: line x.0 t=3847894 -> @@29
@ via @@30 b=10000 p=x d=100000000
@ via @@31 b=10000 p=x d=100000000
@ via @@32 b=10000 p=x d=100000000
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@ via @@37 b=10000 p=x d=100000000
@ via @@38 b=10000 p=x d=100000000
@ via @@39 b=10000 p=x d=100000000
@ via @@40 b=10000 p=x d=100000000
@@41: line x.0 t=103847894 -> @@40
@ via @@31 b=1377 p=x d=1923769
@ via @@32 b=1377 p=x d=1923769
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@ via @@37 b=10000 p=x d=100000000
@ via @@38 b=10000 p=x d=100000000
@ via @@39 b=10000 p=x d=100000000
@ via @@40 b=10000 p=x d=100000000
@ via @@41 b=10000 p=x d=100000000
@@42: line x.0 t=101924225 -> @@31
@ via @@33 b=10000 p=x d=100000000
@ via @@34 b=10000 p=x d=100000000
@ via @@35 b=10000 p=x d=100000000
@ via @@36 b=10000 p=x d=100000000
@ via @@37 b=10000 p=x d=100000000
@ via @@38 b=10000 p=x d=100000000
@ via @@39 b=10000 p=x d=100000000
@ via @@40 b=10000 p=x d=100000000
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@@43: line x.0 t=103847894 -> @@40
@ via @@33 b=0 p=x d=100
@ via @@34 b=0 p=x d=100
@ via @@35 b=1377 p=x d=1923769
@ via @@36 b=1377 p=x d=1923769
@ via @@37 b=10000 p=x d=100000000
@ via @@38 b=10000 p=x d=100000000
@ via @@39 b=10000 p=x d=100000000
@ via @@40 b=10000 p=x d=100000000
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@ via @@43 b=10000 p=x d=100000000
@@44: line x.2 t=100000712 -> @@34
@@45: line x.0 t=101924381 -> @@35
@ via @@37 b=6 p=x d=256
@ via @@38 b=3525 p=x d=12496225
@ via @@39 b=3525 p=x d=12496225
@ via @@40 b=10000 p=x d=100000000
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@@46: line x.2 t=101924381 -> @@37
@@47: line x.0 t=103847894 -> @@40
@ via @@38 b=6 p=x d=256
@ via @@39 b=6 p=x d=256
@ via @@40 b=10000 p=x d=100000000
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@@48: line x.2 t=100000712 -> @@38
@@49: line x.0 t=103847894 -> @@40
@ via @@40 b=1377 p=x d=1923769
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@@50: line x.0 t=5771663 -> @@40
@ via @@40 b=0 p=x d=100
@ via @@41 b=10000 p=x d=100000000
@ via @@42 b=10000 p=x d=100000000
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@ via @@50 b=10000 p=x d=100000000
@@51: line x.2 t=3847994 -> @@40
@@52: line x.0 t=105771663 -> @@50
@ via @@42 b=1377 p=x d=1923769
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@ via @@50 b=10000 p=x d=100000000
@ via @@51 b=10000 p=x d=100000000
@ via @@52 b=10000 p=x d=100000000
@@53: line x.0 t=103847994 -> @@51
@ via @@43 b=10000 p=x d=100000000
@ via @@44 b=10000 p=x d=100000000
@ via @@45 b=10000 p=x d=100000000
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@ via @@50 b=10000 p=x d=100000000
@ via @@51 b=10000 p=x d=100000000
@ via @@52 b=10000 p=x d=100000000
@ via @@53 b=10000 p=x d=100000000
@@54: line x.0 t=103847994 -> @@51
@ via @@44 b=1377 p=x d=1923769
@ via @@45 b=1377 p=x d=1923769
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@ via @@50 b=10000 p=x d=100000000
@ via @@51 b=10000 p=x d=100000000
@ via @@52 b=10000 p=x d=100000000
@ via @@53 b=10000 p=x d=100000000
@ via @@54 b=10000 p=x d=100000000
@@55: line x.0 t=101924481 -> @@44
@ via @@46 b=10000 p=x d=100000000
@ via @@47 b=10000 p=x d=100000000
@ via @@48 b=10000 p=x d=100000000
@ via @@49 b=10000 p=x d=100000000
@ via @@50 b=10000 p=x d=100000000
@ via @@51 b=10000 p=x d=100000000
@ via @@52 b=10000 p=x d=100000000
@ via @@53 b=10000 p=x d=100000000
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@@56: line x.0 t=103847994 -> @@51
@ via @@46 b=0 p=x d=100
@ via @@47 b=0 p=x d=100
@ via @@48 b=1377 p=x d=1923769
@ via @@49 b=1377 p=x d=1923769
@ via @@50 b=10000 p=x d=100000000
@ via @@51 b=10000 p=x d=100000000
@ via @@52 b=10000 p=x d=100000000
@ via @@53 b=10000 p=x d=100000000
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@ via @@56 b=10000 p=x d=100000000
@@57: line x.2 t=101924481 -> @@46
@@58: line x.0 t=101924481 -> @@48
@ via @@50 b=6 p=x d=256
@ via @@51 b=3525 p=x d=12496225
@ via @@52 b=3525 p=x d=12496225
@ via @@53 b=10000 p=x d=100000000
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@@59: line x.0 t=16344219 -> @@51
@@60: line x.2 t=5771919 -> @@50
@ via @@51 b=6 p=x d=256
@ via @@52 b=6 p=x d=256
@ via @@53 b=10000 p=x d=100000000
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@@61: line x.0 t=105771919 -> @@60
@@62: line x.2 t=3848250 -> @@51
@ via @@53 b=1377 p=x d=1923769
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@@63: line x.0 t=103848250 -> @@62
@ via @@53 b=0 p=x d=100
@ via @@54 b=10000 p=x d=100000000
@ via @@55 b=10000 p=x d=100000000
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@ via @@63 b=10000 p=x d=100000000
@@64: line x.2 t=103848094 -> @@53
@@65: line x.0 t=103848250 -> @@62
@ via @@55 b=1377 p=x d=1923769
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@ via @@63 b=10000 p=x d=100000000
@ via @@64 b=10000 p=x d=100000000
@ via @@65 b=10000 p=x d=100000000
@@66: line x.0 t=103848250 -> @@62
@ via @@56 b=10000 p=x d=100000000
@ via @@57 b=10000 p=x d=100000000
@ via @@58 b=10000 p=x d=100000000
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@ via @@63 b=10000 p=x d=100000000
@ via @@64 b=10000 p=x d=100000000
@ via @@65 b=10000 p=x d=100000000
@ via @@66 b=10000 p=x d=100000000
@@67: line x.0 t=103848250 -> @@62
@ via @@57 b=1377 p=x d=1923769
@ via @@58 b=1377 p=x d=1923769
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@ via @@63 b=10000 p=x d=100000000
@ via @@64 b=10000 p=x d=100000000
@ via @@65 b=10000 p=x d=100000000
@ via @@66 b=10000 p=x d=100000000
@ via @@67 b=10000 p=x d=100000000
@@68: line x.0 t=103848250 -> @@62
@ via @@59 b=10000 p=x d=100000000
@ via @@60 b=10000 p=x d=100000000
@ via @@61 b=10000 p=x d=100000000
@ via @@62 b=10000 p=x d=100000000
@ via @@63 b=10000 p=x d=100000000
@ via @@64 b=10000 p=x d=100000000
@ via @@65 b=10000 p=x d=100000000
@ via @@66 b=10000 p=x d=100000000
@ via @@67 b=10000 p=x d=100000000
@ via @@68 b=10000 p=x d=100000000
@@69: line x.0 t=103848250 -> @@62
@ via @@59 b=0 p=x d=100
@ via @@60 b=0 p=x d=100
@ via @@61 b=1377 p=x d=1923769
@ via @@62 b=1377 p=x d=1923769
@ via @@63 b=10000 p=x d=100000000
@ via @@64 b=10000 p=x d=100000000
@ via @@65 b=10000 p=x d=100000000
@ via @@66 b=10000 p=x d=100000000
@ via @@67 b=10000 p=x d=100000000
@ via @@68 b=10000 p=x d=100000000
@ via @@69 b=10000 p=x d=100000000
@@70: line x.0 t=5772019 -> @@62
@@71: line x.2 t=5772019 -> @@60
@ via @@63 b=6 p=x d=256
@ via @@64 b=3525 p=x d=12496225
@ via @@65 b=3525 p=x d=12496225
@ via @@66 b=10000 p=x d=100000000
@ via @@67 b=10000 p=x d=100000000
@ via @@68 b=10000 p=x d=100000000
@ via @@69 b=10000 p=x d=100000000
@ via @@70 b=10000 p=x d=100000000
@ via @@71 b=10000 p=x d=100000000
@@72: line x.0 t=105772019 -> @@71
@@73: line x.2 t=103848506 -> @@63
@ via @@64 b=6 p=x d=256
@ via @@65 b=6 p=x d=256
@ via @@66 b=10000 p=x d=100000000
@ via @@67 b=10000 p=x d=100000000
@ via @@68 b=10000 p=x d=100000000
@ via @@69 b=10000 p=x d=100000000
@ via @@70 b=10000 p=x d=100000000
@ via @@71 b=10000 p=x d=100000000
@ via @@72 b=10000 p=x d=100000000
@ via @@73 b=10000 p=x d=100000000
@@74: line x.2 t=103848350 -> @@64
@@75: line x.0 t=105772019 -> @@71
@ via @@66 b=1377 p=x d=1923769
@ via @@67 b=10000 p=x d=100000000
@ via @@68 b=10000 p=x d=100000000
@ via @@69 b=10000 p=x d=100000000
@ via @@70 b=10000 p=x d=100000000
@ via @@71 b=10000 p=x d=100000000
@ via @@72 b=10000 p=x d=100000000
@ via @@73 b=10000 p=x d=100000000
@ via @@74 b=10000 p=x d=100000000
@ via @@75 b=10000 p=x d=100000000
@@76: line x.0 t=105772019 -> @@71
@ via @@66 b=0 p=x d=100
@ via @@67 b=0 p=x d=100
@ via @@68 b=0 p=x d=100
@ via @@69 b=0 p=x d=100
@ via @@70 b=0 p=x d=100
@ via @@71 b=0 p=x d=100
@ via @@72 b=0 p=x d=100
@ via @@73 b=0 p=x d=100
@ via @@74 b=0 p=x d=100
@ via @@75 b=0 p=x d=100
@@77: line x.2 t=5772119 -> @@71`;